import '@marso2/m-styles-core/dist/index.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import statistics from '@marso2/frontend-shared-components/src/statistics.js';

import {setReferralProvider} from '@marso2/frontend-shared-components/src/api/http-common';

const app = createApp(App);

app.use(statistics);
app.use(createPinia());
app.use(router);

const url = new URL(window.location.href);

if (
  url.searchParams.has('order_token') ||
  url.searchParams.has('ysclid')
) {
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, follow';
  document.head.appendChild(meta);
}

setReferralProvider(() => router._tempAuthReferralId || router.currentRoute.value?.query?.authReferralId);
app.mount('#app');
